(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["breadcrumb"] && !Shopify.designMode) return;
  try {
    class BreadcrumbsNav extends HTMLElement {
    /** @type {HTMLButtonElement | null} */
    #ellipsisButton = null;
    /** @type {(() => void) | null} */
    #onEllipsisClick = null;

    connectedCallback() {
      this.#ellipsisButton = this.querySelector('.breadcrumbs__ellipsis');

      if (!this.#ellipsisButton) return;

      this.#onEllipsisClick = () => this.#expand();
      this.#ellipsisButton.addEventListener('click', this.#onEllipsisClick);
    }

    disconnectedCallback() {
      if (this.#ellipsisButton && this.#onEllipsisClick) {
        this.#ellipsisButton.removeEventListener('click', this.#onEllipsisClick);
      }

      this.#ellipsisButton = null;
      this.#onEllipsisClick = null;
    }

    #expand() {
      const ellipsisItem = this.querySelector('.breadcrumbs__item--ellipsis');
      const collapsedItems = this.querySelectorAll('.breadcrumbs__item--collapsed');

      for (const item of collapsedItems) {
        item.hidden = false;
        item.classList.remove('breadcrumbs__item--collapsed');
      }

      if (this.#ellipsisButton) {
        this.#ellipsisButton.setAttribute('aria-expanded', 'true');
      }

      if (ellipsisItem instanceof HTMLElement) {
        ellipsisItem.hidden = true;
      }

      this.querySelector('.breadcrumbs')?.classList.remove('breadcrumbs--collapsible');
    }
  }

  if (!customElements.get('breadcrumbs-nav')) {
    customElements.define('breadcrumbs-nav', BreadcrumbsNav);
  }
  } catch(e) { console.error(e); }
})();

})();
